/*
  bn-clean-prices.js
  Drops a trailing ".00" from displayed USD prices so whole amounts read
  clean:  $39.00 -> $39 ,  $1,250.00 -> $1,250 ,  $39.00 USD -> $39 USD.
  Real decimals are kept untouched:  $39.95 stays $39.95.

  Works at the display layer over every server-rendered price (Dawn renders
  all money through Liquid, including cart-drawer / variant / quantity
  updates via the Section Rendering API), and a MutationObserver keeps those
  later re-renders clean too. USD/$ store — see brand memory.
*/
(function () {
  // $ + digits (with optional thousands commas) + .00 not followed by a digit.
  var RE = /(\$\d[\d,]*)\.00(?!\d)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1 };

  function cleanTextNode(node) {
    var v = node.nodeValue;
    if (!v || v.indexOf('.00') === -1 || v.indexOf('$') === -1) return;
    var parent = node.parentNode;
    if (parent && SKIP[parent.nodeName]) return;
    var next = v.replace(RE, '$1');
    if (next !== v) node.nodeValue = next; // no-op on already-clean text => no observer loop
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) return cleanTextNode(root);
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) cleanTextNode(n);
  }

  function init() {
    walk(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') {
          cleanTextNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
